var map = {
	"./business-bg.jpg": 5425,
	"./business/example_img (1).jpg": 9796,
	"./business/example_img (2).jpg": 8269,
	"./business/example_img (3).jpg": 9650,
	"./business/example_img (4).jpg": 9971,
	"./business/example_img (5).jpg": 9200,
	"./business/example_img (6).jpg": 985,
	"./business/image10.png": 2444,
	"./business/image11.png": 8357,
	"./business/image12.png": 2606,
	"./business/image12_white.png": 8964,
	"./business/image13.png": 5095,
	"./business/image14.jpeg": 1797,
	"./business/image15.png": 5697,
	"./business/image16.png": 4586,
	"./business/image17.png": 2339,
	"./business/image18.png": 8468,
	"./business/image19.png": 2365,
	"./business/image20.jpeg": 286,
	"./business/image21.png": 5384,
	"./business/image22.png": 9728,
	"./business/image23.png": 5434,
	"./business/image24.png": 5861,
	"./business/image25.png": 9948,
	"./business/image26.png": 7527,
	"./business/image27.png": 8030,
	"./business/image8.png": 8063,
	"./business/image9.png": 4137,
	"./business/设备专项维修服务1.jpg": 1810,
	"./business/设备专项维修服务2.jpg": 1069,
	"./business/设备年度保障服务.jpg": 6500,
	"./business/设备搬迁一条龙服务.jpg": 6620,
	"./business/设备状态检测服务（三级维护）.jpg": 3852,
	"./business/设备针对性维修服务1.jpg": 1222,
	"./business/设备针对性维修服务2.jpg": 8977,
	"./business/设备集中深度保养服务（二级维护）.jpg": 495,
	"./capability/image32.jpeg": 3741,
	"./capability/image33.png": 7769,
	"./capability/image34.png": 4694,
	"./capability/image35.png": 3711,
	"./capability/image36.png": 4804,
	"./capability/image37.png": 5933,
	"./capability/image38.jpeg": 5627,
	"./capability/image39.jpeg": 4468,
	"./capability/image40.jpeg": 2136,
	"./capability/image41.png": 4358,
	"./capability/image42.jpeg": 5474,
	"./capability/image43.jpeg": 697,
	"./capability/image44.jpeg": 9676,
	"./capability/image45.jpeg": 4979,
	"./capability/image46.jpeg": 5414,
	"./capability/image47.png": 528,
	"./capability/image48.jpg": 6311,
	"./contact qrcode.jpg": 409,
	"./custom/example_img (1).jpg": 967,
	"./custom/example_img (2).jpg": 6482,
	"./custom/example_img (3).jpg": 5661,
	"./custom/image28.png": 3386,
	"./custom/image29.png": 4611,
	"./custom/image30.png": 5741,
	"./custom/image31.png": 4612,
	"./gallery/after-cleaning.jpg": 4228,
	"./gallery/balancing-kit.jpg": 3994,
	"./gallery/before-cleaning.jpg": 9235,
	"./gallery/deep-cleaning-detail.jpg": 2690,
	"./gallery/dial-indicator.jpg": 216,
	"./gallery/dirty-case.jpg": 8515,
	"./gallery/dirty-servo.jpg": 768,
	"./gallery/electric-meter.jpg": 7327,
	"./gallery/field-diagnosis-1.jpg": 8038,
	"./gallery/heavy-maintenance.jpg": 2127,
	"./gallery/laser-diagnosis.jpg": 8669,
	"./gallery/oil-mist-line.jpg": 2121,
	"./gallery/onsite-control.jpg": 1648,
	"./gallery/precision-parts.jpg": 485,
	"./gallery/rail-after.jpg": 8899,
	"./gallery/rail-before.jpg": 1384,
	"./gallery/relocation-lifting.jpg": 834,
	"./gallery/relocation-team.jpg": 2776,
	"./gallery/renishaw-kit.jpg": 1588,
	"./gallery/spindle-tension.jpg": 100,
	"./gallery/stability-system.jpg": 119,
	"./gallery/thermal-imaging.jpg": 2620,
	"./hero/hero_bg_image.png": 850,
	"./hero/show1.jpg": 9890,
	"./hero/show2.jpg": 4045,
	"./hero/show3.jpg": 5952,
	"./team/photo (1).jpeg": 756,
	"./team/photo (2).jpeg": 4499,
	"./team/photo (3).jpeg": 102,
	"./team/photo (4).jpeg": 3797
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;